module.exports = __webpack_public_path__ + "media/images/media/media5-8c2b1cc9798ce0d6a9272b4030181b14.jpg";